import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import shortId from "shortid";

import "./LinkWithButton.scss";

const LinkWithButton = ({ link, isYoutube })=> {
  const [isMessageVisible, setMessageFlag] = useState(false);
  const [elementId, setId] = useState("");

  useEffect(()=> {
     setId(`link-element-${shortId()}`)
  }, []);

  const handleClick = ()=> {
    if(isYoutube) {
      window.open(link,'_blank');
      return;
    }
    const element = document.getElementById(elementId);
    element.select();
    document.execCommand("copy");
    setMessageFlag(true);
    setTimeout(()=> setMessageFlag(false), 3000);
  };

  return (
    <div className="link-with-button">
      <input id={elementId} value={link} className="link-with-button__link" />
      <button 
        className={`link-with-button__button link-with-button__button--${isYoutube ? "youtube" : "regular"}`}
        onClick={handleClick} 
      >
        {isYoutube ? "Go To Youtube" : "Copy link"}    
      </button>
      <span 
        className={`link-with-button__success-message ${isMessageVisible ? "link-with-button__success-message--visible" : "" }`}
      >
        Copied to clipboard
      </span>
    </div>
  );
};

LinkWithButton.propTypes = {
  isYoutube: PropTypes.bool,
  link: PropTypes.string
};

LinkWithButton.defaultProps = {
  isYoutube: false,
  link: ""
}

export default LinkWithButton;